import { useEffect, useState } from "react";

import { defaultLayoutDimensions } from "../config";
import { LayoutDimension } from "../types";

/**
 * dynamically update the dimension with the container size
 * @param containerId the id of the container element
 * @param dimension dimension to be updated
 * @returns Layout dimension that stays in sync with the container with said ID
 */
const useUpdateDimension = (
  containerId?: string,
  dimension: LayoutDimension = defaultLayoutDimensions
) => {
  const [size, setSize] = useState(dimension);

  useEffect(() => {
    if (!containerId) return;
    const element = document.getElementById(containerId);
    if (!element) return;

    const resizeObserver = new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      setSize({ ...dimension, width });
    });

    resizeObserver.observe(element);

    return () => {
      resizeObserver.unobserve(element);
    };
  }, [containerId, dimension]);

  return size;
};

export default useUpdateDimension;
